import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@src/lib/ui/AlertDialog";
import { Button } from "@src/lib/ui/Button";
import { FC } from "react";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  locationName: string;
  onDelete: () => Promise<void>;
};

export const DeleteHrisLocationDialog: FC<Props> = ({
  open,
  onOpenChange,
  locationName,
  onDelete,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete HRIS location?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>
              <div className="mb-3">
                Are you sure you want to delete the HRIS location &quot;
                {locationName}
                &quot;? This action cannot be undone.
              </div>
              <div>
                If the HRIS Location being deleted still exists in your HRIS, it
                will get recreated in opus during the next sync. Therefore,
                deleting HRIS locations is usually only necessary or useful in
                rare circumstances.
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onDelete}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
